import toast from "react-hot-toast"
import Axios from 'axios'
import { ABI_APPROVAL, ABI_BEP, ABI_SWAP, API } from "./constants"
import web3 from 'web3'

export function redirectToMetamask() {
    if (/* 'ontouchstart' in window || 'onmsgesturechange' in window ||  */!window.ethereum) {
        window.open("https://metamask.app.link/dapp/strmbridge.com")
        return true
    } else {
        return false
    }
}

export const walletConnectHandler = async () => {
    try {
        let check = redirectToMetamask()
        if (!check) {
            let res = await window.ethereum.enable()
            return res[0]
        }
    } catch (error) {
        // console.log(error)
        toast.error(error.message)
    }

}

export const getNetworkPairs = async () => {
    try {
        let res = await Axios.post(`${API}/get_network_pairs/`, {})
        return res.data.data[0]
    } catch (error) {
        toast.error(error.message)
    }
}

export const getNetworks = async () => {
    try {
        let res = await Axios.post(`${API}/fetch_all_network/`, {})
        return res.data.data[0]
    } catch (error) {
        toast.error(error.message)
    }
}
export const switchNetwork = async (val, network_list) => {
    if (window.ethereum) {
        try {
            await window.ethereum.request({
                method: 'wallet_switchEthereumChain',
                params: [{ chainId: network_list[val].chainID }],
            });
            return true
        } catch (switchError) {
            // This error code indicates that the chain has not been added to MetaMask.
            if (switchError.code === 4902) {
                try {
                    await window.ethereum.request({
                        method: 'wallet_addEthereumChain',
                        params: [
                            {
                                chainId: network_list[val].chainID,
                                chainName: network_list[val].chainName,
                                rpcUrls: [network_list[val].node],
                                nativeCurrency: {
                                    name: network_list[val].metamask_symbol,
                                    symbol: network_list[val].metamask_symbol,// 2-6 characters long
                                    decimals: 18
                                },
                                blockExplorerUrls: [network_list[val].explorer_url]
                            },
                        ],
                    });
                } catch (error) {
                    // handle "add" error
                    if (error.code === -32602) {
                        await window.ethereum.request({
                            method: "wallet_switchEthereumChain",
                            params: [{ chainId: network_list[val].chainID }],
                        });
                        return
                    }
                    // console.log(error.code)
                    if (error.code === -32002) {
                        toast.error("Request already pending.")

                    } else {
                        toast.error(error.message)
                    }
                }
            }
            // handle other "switch" errors
        }
        // try {
        //     await window.ethereum.request({
        //         method: "wallet_addEthereumChain",
        //         params: [
        //             {
        //                 chainId: network_list[val].chainID,
        //                 chainName: network_list[val].chainName,
        //                 rpcUrls: [network_list[val].node],
        //                 nativeCurrency: {
        //                     name: network_list[val].metamask_symbol,
        //                     symbol: network_list[val].metamask_symbol,// 2-6 characters long
        //                     decimals: 18
        //                 },
        //                 blockExplorerUrls: [network_list[val].explorer_url]
        //             },
        //         ],
        //     });
        //     await window.ethereum.request({
        //         method: "wallet_switchEthereumChain",
        //         params: [{ chainId: network_list[val].chainID }],
        //     });
        //     return true

        // } catch (error) {
        //     if (error.code === -32602) {
        //         await window.ethereum.request({
        //             method: "wallet_switchEthereumChain",
        //             params: [{ chainId: network_list[val].chainID }],
        //         });
        //         return
        //     }
        //     // console.log(error.code)
        //     if (error.code === -32002) {
        //         toast.error("Request already pending.")

        //     } else {
        //         toast.error(error.message)
        //     }

        // }
    } else {
        toast.error("Please install Metamask.")
    }
};


export const callWeb3Approval = async (contractAdd, walletAdd, crossAdd, network) => {
    let abi = network === "BSC" ? ABI_APPROVAL.BSC : ABI_APPROVAL.other
    // console.log(contractAdd, walletAdd, crossAdd, network)
    let myContract = new window.web3.eth.Contract(
        abi,
        contractAdd
    );
    let check = await myContract.methods
        .allowance(walletAdd, crossAdd)
        .call();
    return check
}

export const callWeb3SetLimit = async (contractAdd, amt, crossAdd, network, acc, gasFee) => {
    let selected = window.web3.utils.toChecksumAddress(
        window.ethereum.selectedAddress
    );
    let abi = network === "BSC" ? ABI_APPROVAL.BSC : ABI_APPROVAL.other
    let myContract = new window.web3.eth.Contract(
        abi,
        contractAdd
    );
    let limit = null
    if (network === "MATIC") {
        limit = await myContract.methods
            .approve(crossAdd, amt.toString())
            .send({
                from: selected, maxPriorityFeePerGas: gasFee
            });
        toast.success("Limit has been set. Swap Now.")

        return limit
    }

    if (network === "FTM") {
        limit = await myContract.methods
            .approve(crossAdd, amt.toString())
            .send({
                from: selected, gasPrice: gasFee
            });
        toast.success("Limit has been set. Swap Now.")

        return limit
    }

    limit = await myContract.methods
        .approve(crossAdd, amt.toString())
        .send({
            from: selected
        });
    toast.success("Limit has been set. Swap Now.")
    return limit

}

export const callWeb3Balance = async (walletAdd, network, contractAdd) => {
    let abi = network === "BSC" ? ABI_APPROVAL.BSC : ABI_APPROVAL.other
    let myContract = new window.web3.eth.Contract(
        abi,
        contractAdd
    );
    let bal = await myContract.methods
        .balanceOf(walletAdd)
        .call();
    return bal


}
export const callWeb3Decimals = async (network, contractAdd) => {
    let abi = network === "BSC" ? ABI_APPROVAL.BSC : ABI_APPROVAL.other
    let myContract = new window.web3.eth.Contract(
        abi,
        contractAdd
    );
    let dec = await myContract.methods
        .decimals()
        .call();
    return dec
}

// export const callWeb3Swap = async (network, crossAdd, contractAdd, amt, toNetwork, swapFee, gasFee) => {

//     let selected = window.web3.utils.toChecksumAddress(
//         window.ethereum.selectedAddress
//     );
//     let abi = network === "BSC" ? ABI_SWAP.BSC : ABI_SWAP.other
//     let myContract = new window.web3.eth.Contract(
//         abi,
//         crossAdd,
//     );
//     // let fee = await myContract.methods
//     //     .swapFee()
//     //     .call();
//     // let swapFee = await myContract.methods.swapFee().call();

//     let swap = null
//     let estimatedGasFee = await window.web3.eth.estimateGas({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), gasPrice: gasFee })

//     if (network === "MATIC") {
//         swap = await myContract.methods
//             .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
//             .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), maxPriorityFeePerGas: gasFee, gasLimit: '300000' });
//         return swap
//     }
//     if (network === "FTM" || network === "BSC") {

//         swap = await myContract.methods
//             .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
//             .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), gasPrice: gasFee, gasLimit: estimatedGasFee * 2 });
//         return swap
//     }

//     swap = await myContract.methods
//         .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
//         .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), gasLimit: estimatedGasFee * 2 });
//     return swap


// }
export const callWeb3Swap = async (network, crossAdd, contractAdd, amt, toNetwork, swapFee, gasFee) => {
    let selected = window.web3.utils.toChecksumAddress(
        window.ethereum.selectedAddress
    );
    let abi = network === "BSC" ? ABI_SWAP.BSC : ABI_SWAP.other
    let myContract = new window.web3.eth.Contract(
        abi,
        crossAdd,
    );
    let estimatedGasFee = await window.web3.eth.estimateGas({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), gasPrice: gasFee })

    if (network === "MATIC") {
        let swap = await myContract.methods
            .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
            .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), maxPriorityFeePerGas: gasFee });
        return swap
    }

    if (network === "FTM" || network === "BSC") {

        let swap = await myContract.methods
            .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
            .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether'), gasPrice: gasFee, gasLimit: estimatedGasFee * 3 });
        return swap
    }

    let swap = await myContract.methods
        .swapToken(contractAdd, amt.toString(), toNetwork.toUpperCase())
        .send({ from: selected, value: window.web3.utils.toWei(swapFee, 'ether') });
    return swap


}
export const sendTransDetails = async (data) => {
    try {
        let res = await Axios.post(`${API}/swap/`, data)
        return res.data
    } catch (error) {
        toast.error(error.message)
    }
}

export const checkMode = () => {
    if (localStorage.getItem("mode")) {
        return localStorage.getItem("mode")
    } else {
        return false
    }
}

export const checkSidebarStatus = () => {
    if (localStorage.getItem("sidebarStatus")) {
        return localStorage.getItem("sidebarStatus")
    } else {
        return false
    }
}

export const getRequestDet = async (params) => {
    let data = await Axios.post(`${API.user_API}/fetchrequest/`, { ...params })
    return data
}

export const getTransactionHistory = async (params) => {
    // console.log(params, "params")
    let data = await Axios.post(`${API}/check_history_details/`, params)
    return data
}

export const getStatus = async (params) => {
    let data = await Axios.post(`${API}/check_status/`, params)
    return data
}
// request_id